import { apiClient } from "../apiClient";
import { API_ENDPOINTS } from "@repo/constants";
import { AxiosError } from "axios";
import {
    CreateRoleRequest,
    CreateRoleResponse,
    RoleListRequest,
    RoleApiResponse,
    UpdateRoleRequest,
    UpdateRoleResponse,
} from "@repo/types";

export const CreateRole = async (
    payload: Partial<CreateRoleRequest>
): Promise<CreateRoleResponse> => {
    try {
        const response = await apiClient.post<CreateRoleResponse>(
            API_ENDPOINTS.createRole,
            payload
        );
        return response.data;
    } catch (err) {
        const error = err as AxiosError<any>;
        console.error("Error creating role:", error);
        const apiMessage =
            error.response?.data?.Message ||
            error.message ||
            "An unexpected error occurred";
        return { Success: false, Message: apiMessage, StatusCode: 500 };
    }
};

export const RoleList = async (
    payload: Partial<RoleListRequest>
): Promise<RoleApiResponse> => {
    try {
        const response = await apiClient.post<RoleApiResponse>(
            API_ENDPOINTS.roleList,
            payload
        );
        return response.data;
    } catch (err) {
        const error = err as AxiosError<any>;
        console.error("Error fetching role list:", error);
        const apiMessage =
            error.response?.data?.Message ||
            error.message ||
            "An unexpected error occurred";
        return {
            Success: false,
            Message: apiMessage,
            StatusCode: 500,
            Data: [],
        };
    }
};

export const UpdateRole = async (
    payload: Partial<UpdateRoleRequest>
): Promise<UpdateRoleResponse> => {
    try {
        const response = await apiClient.post<UpdateRoleResponse>(
            API_ENDPOINTS.updateRole,
            payload
        );
        return response.data;
    } catch (err) {
        const error = err as AxiosError<any>;
        console.error("Error updating role:", error);
        const apiMessage =
            error.response?.data?.Message ||
            error.message ||
            "An unexpected error occurred";
        return { Success: false, Message: apiMessage, StatusCode: 500 };
    }
};
